import { formatISO, parseISO } from 'date-fns';
import { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function Input(props) {
  const {
    value, pattern, accept, placeholder, maxLength, id, name, type, error, required, showLabel = true, onChange = () => { }, onKeyDown = () => { }, onBlur = () => { }, className = null, min, max, step, disabled, isClearable = false, removeDatePickerPt = false,
  } = props;

  const [focus, setFocus] = useState(false);
  const ref = useRef();
  const v = value;

  useEffect(() => {
    if (error) {
      ref.current.scrollIntoView({ block: 'end', behavior: 'smooth' });
    }
  }, [error]);

  const handleChangeDate = (date) => {
    const dateValue = !date ? '' : formatISO(date, { representation: 'date' });
    onChange(dateValue);
  };

  function datePickerClassName() {
    const defaultClassName = 'relative z-10 border-0 focus:outline-none focus:ring-0 w-full bg-transparent font-semibold text-base p-2 pl-3 pr-3 text-sentric-dark-gray';

    if (removeDatePickerPt) return `${defaultClassName} p-3`;

    return [
      'border-0 focus:outline-none focus:ring-0 w-full bg-transparent font-semibold text-base p-2 pl-3 pr-3 text-sentric-dark-gray',
      ((v && v.toString().length > 0) || (v === 0) || ['file'].includes(type)) ? 'pt-6' : '',
    ].join(' ');
  }

  return (
    <div ref={ref} className={`${className}`}>
      <div className={`relative font-semibold text-base bg-white block w-full border border-sentric-table-border rounded-md ${focus ? 'ring-1 ring-sentric-dark-gray ring-opacity-50' : ''} ${required ? 'required-star' : ''} ${disabled ? 'bg-gray-100 opacity-60' : ''}`}>
        {type !== 'date'
          && (
            <input
              disabled={disabled}
              className={[
                'border-0 focus:outline-none focus:ring-0 w-full bg-transparent font-semibold text-base p-2 pl-3 pr-3 text-sentric-dark-gray',
                ((v && v.toString().length > 0) || (v === 0) || ['file'].includes(type)) ? 'pt-6' : '',
              ].join(' ')}
              id={id}
              name={name}
              value={v}
              type={type || 'text'}
              onFocus={() => setFocus(true)}
              onBlur={(e) => { setFocus(false); onBlur(e); }}
              onChange={onChange}
              onKeyDown={onKeyDown}
              min={min}
              pattern={pattern}
              max={max}
              maxLength={maxLength}
              step={step}
              accept={accept}
              onWheel={(event) => event.currentTarget.blur()}
            />
          )}
        {type === 'date'
          && (
            <DatePicker
              id={id}
              selected={v ? parseISO(v) : null}
              onChange={handleChangeDate}
              className={datePickerClassName()}
              dateFormat="yyyy/MM/dd"
              placeholderText={placeholder}
              isClearable={isClearable}
              minDate={min}
              maxDate={max}
            />
          )}
        {showLabel && (
          <label
            className={[
              'absolute pointer-events-none top-0 left-0 flex items-center text-gray-500 p-2 pl-3 pr-3',
              ((v && v.toString().length > 0) || (v === 0) || ['file'].includes(type)) ? 'text-xs' : 'text-base',
            ].join(' ')}
            htmlFor={name}
          >
            {placeholder}
          </label>
        )}

      </div>
      {!!error
        && <p className="w-4/5 error-arrow-top text-sm inline-block p-1 pr-3 pl-3 bg-red-700 mt-2 text-white rounded-lg border-white border">{error}</p>}
    </div>

  );
}

export default Input;
